<div class="row" *ngIf="hasFilterContent">
    <div class="col-lg-12 bold settings-section">
        <label>Filter Data:</label>
    </div>
</div>
<ng-content></ng-content>

<ng-container *ngIf="showSharedSettings">
    <div class="row">
        <!-- general-chart-settings -->
        <div class="col-lg-12 bold settings-section" style="padding-left: 15px">
            <label>Display Settings:</label>
        </div>
    </div>

    <!-- Chart Type -->
    <div class="row">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="selectChartType"
                       title="Type of chart to display: pie, doughnut, bar, line, etc">
                    Chart Type
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('chartType')"
                            (click)="onInfoClick($event, 'chartType')">
                        i
                    </button>
                </label>
                <select id="selectChartType"
                        name="selectChartType"
                        [(ngModel)]="selectedChartType"
                        class="form-control"
                        (click)="hideTooltip()">
                    <option value="" [selected]="selectedChartType === ''">
                        -- Select Chart Type --
                    </option>
                    <option *ngFor="let chartType of chartTypeOptions"
                            [value]="chartType">
                        {{
              chartType.charAt(0).toUpperCase() +
              chartType.slice(1).toLowerCase()
                        }}
                    </option>
                </select>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('chartType')"
                     (click)="hideTooltip()">
                    {{ info('chartType') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Show Filter -->
    <div class="row" *ngIf="selectedChartType == 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="showFilter"
                       class="control-group input-group-addon"
                       title="Enable filtering for the list">
                    Show Filter
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('showFilter')"
                            (click)="onInfoClick($event, 'showFilter')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="showFilter"
                           class="form-check-input"
                           [(ngModel)]="showFilter" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('showFilter')"
                     (click)="hideTooltip()">
                    {{ info('showFilter') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Paginate -->
    <div class="row" *ngIf="selectedChartType == 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="paginate"
                       class="control-group input-group-addon"
                       title="Enable pagination for the list">
                    Paginate
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('paginate')"
                            (click)="onInfoClick($event, 'paginate')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="paginate"
                           class="form-check-input"
                           [(ngModel)]="paginate" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('paginate')"
                     (click)="hideTooltip()">
                    {{ info('paginate') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Page Size -->
    <div class="row" *ngIf="selectedChartType == 'list' && paginate">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="pageSize"
                       class="control-group input-group-addon"
                       title="Number of rows per page">
                    Page Size
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('pageSize')"
                            (click)="onInfoClick($event, 'pageSize')">
                        i
                    </button>
                </label>
                <input id="pageSize"
                       name="pageSize"
                       type="number"
                       class="form-control"
                       [(ngModel)]="pageSize"
                       min="1"
                       max="100"
                       (click)="hideTooltip()" />

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('pageSize')"
                     (click)="hideTooltip()">
                    {{ info('pageSize') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Show All Data -->
    <div class="row" *ngIf="selectedChartType == 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="showAllData"
                       class="control-group input-group-addon"
                       title="Display all possible data">
                    Show All Data
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('showAllData')"
                            (click)="onInfoClick($event, 'showAllData')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="showAllData"
                           class="form-check-input"
                           [(ngModel)]="showAllData" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('showAllData')"
                     (click)="hideTooltip()">
                    {{ info('showAllData') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Responsive -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="setResponsive"
                       title="Chart will resize based on window">
                    Responsive
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('responsive')"
                            (click)="onInfoClick($event, 'responsive')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="setResponsive"
                           class="form-check-input"
                           [(ngModel)]="responsive" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('responsive')"
                     (click)="hideTooltip()">
                    {{ info('responsive') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Color Scheme -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;"
                 (click)="openColorSchemePickerModal()">
                <label class="control-group input-group-addon"
                       for="colorScheme"
                       title="Colors assigned to datapoints">
                    Color Scheme
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('colorScheme')"
                            (click)="$event.stopPropagation(); onInfoClick($event, 'colorScheme')">
                        i
                    </button>
                </label>
                <div class="form-control" style="height: unset">
                    <div class="color-scheme-preview" *ngIf="selectedColorScheme?.length">
                        <div *ngFor="let color of selectedColorScheme"
                             [style.background-color]="color"
                             class="color-box"></div>
                    </div>
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('colorScheme')"
                     (click)="$event.stopPropagation(); hideTooltip()">
                    {{ info('colorScheme') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Background Color -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-10">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="backgroundColor"
                       title="Canvas color">
                    Background Color
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('backgroundColor')"
                            (click)="onInfoClick($event, 'backgroundColor')">
                        i
                    </button>
                </label>
                <input name="backgroundColor"
                       class="form-control"
                       [value]="backgroundColor"
                       [style.background]="backgroundColor"
                       [(colorPicker)]="backgroundColor"
                       [cpPosition]="'top'"
                       (click)="hideTooltip()" />

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('backgroundColor')"
                     (click)="hideTooltip()">
                    {{ info('backgroundColor') }}
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <button class="btn btn-default"
                    (click)="setDefaultBgColor(); hideTooltip()"
                    title="Reset to Default">
                <i class="fa fa-refresh"></i>
            </button>
        </div>
    </div>

    <!-- Show Borders -->
    <div class="row"
         *ngIf="selectedChartType == 'pie' || selectedChartType == 'doughnut'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="showBorder"
                       class="control-group input-group-addon"
                       title="Borders between datapoints in pie and doughnut charts">
                    Show Borders
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('showBorder')"
                            (click)="onInfoClick($event, 'showBorder')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="showBorder"
                           class="form-check-input"
                           [(ngModel)]="showBorder" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('showBorder')"
                     (click)="hideTooltip()">
                    {{ info('showBorder') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Padding -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       style="vertical-align: top; white-space: break-spaces; text-align: left; line-height: 1.5em;"
                       title="Amount of whitespace between rendered content and edge of chart">
                    Padding
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('padding')"
                            (click)="onInfoClick($event, 'padding')">
                        i
                    </button>
                </label>
                <!-- inputs -->
                <div class="form-control" style="height: unset" (click)="hideTooltip()">
                    <div class="form-group">
                        <label for="paddingTop">Top</label>
                        <input id="paddingTop" type="number" class="form-control"
                               [(ngModel)]="padding.top"
                               (change)="emitSettingsChange()" />
                    </div>
                    <div class="form-group">
                        <label for="paddingRight">Right</label>
                        <input id="paddingRight" type="number" class="form-control"
                               [(ngModel)]="padding.right"
                               (change)="emitSettingsChange()" />
                    </div>
                    <div class="form-group">
                        <label for="paddingBottom">Bottom</label>
                        <input id="paddingBottom" type="number" class="form-control"
                               [(ngModel)]="padding.bottom"
                               (change)="emitSettingsChange()" />
                    </div>
                    <div class="form-group">
                        <label for="paddingLeft">Left</label>
                        <input id="paddingLeft" type="number" class="form-control"
                               [(ngModel)]="padding.left"
                               (change)="emitSettingsChange()" />
                    </div>
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('padding')"
                     (click)="hideTooltip()">
                    {{ info('padding') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Legend -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12 bold settings-section">
            <label>Legend:</label>
        </div>
    </div>

    <!-- Show Legend -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="showLegend"
                       class="control-group input-group-addon"
                       title="Display legend/key">
                    Show Legend
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('showLegend')"
                            (click)="onInfoClick($event, 'showLegend')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="showLegend"
                           class="form-check-input"
                           [(ngModel)]="showLegend" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('showLegend')"
                     (click)="hideTooltip()">
                    {{ info('showLegend') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Legend Position -->
    <div class="row" *ngIf="showLegend && selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="legendPosition"
                       title="Position of the legend relative to chart">
                    Legend Position
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('legendPosition')"
                            (click)="onInfoClick($event, 'legendPosition')">
                        i
                    </button>
                </label>
                <select id="legendPosition"
                        name="legendPosition"
                        [(ngModel)]="legendPosition"
                        class="form-control"
                        (click)="hideTooltip()">
                    <option *ngFor="let position of legendPositionOptions"
                            [value]="position">
                        {{ position.charAt(0).toUpperCase() + position.slice(1).toLowerCase() }}
                    </option>
                </select>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('legendPosition')"
                     (click)="hideTooltip()">
                    {{ info('legendPosition') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Legend/Hover Labels or Columns -->
    <div class="row" *ngIf="selectedChartType != 'list' || !showAllData">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       style="vertical-align: top; white-space: break-spaces; text-align: left; line-height: 1.5em;"
                       title="Choose what data displays in legend and hover labels">
                    {{ selectedChartType == "list" ? "Columns" : "Legend/Hover Labels" }}
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('legendLabelsChooser')"
                            (click)="onInfoClick($event, 'legendLabelsChooser')">
                        i
                    </button>
                </label>
                <!-- checkboxes -->
                <div class="form-control"
                     [ngStyle]="{
                        height: 'unset',
                        'min-height':
                          (labelSetOptions | includeSelected : selectedLabelSetOptions)
                            ?.length === 1
                            ? '63px'
                            : null
                      }"
                     (click)="hideTooltip()">
                    <div *ngFor="let option of labelSetOptions" class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [id]="option"
                               [value]="option"
                               [checked]="selectedLabelSetOptions.includes(option)"
                               (change)="toggleLabelOption(option, $event)" />
                        <label [for]="option" class="form-check-label">{{ option }}</label>
                    </div>
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('legendLabelsChooser')"
                     (click)="hideTooltip()">
                    {{ info('legendLabelsChooser') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Data Point Labels header -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12 bold settings-section">
            <label>Data Point Labels:</label>
        </div>
    </div>

    <!-- Show Chart Labels -->
    <div class="row" *ngIf="selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label for="showChartLabels"
                       class="control-group input-group-addon"
                       title="Labels placed above each datapoint">
                    Show Datapoint Labels
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('showChartLabels')"
                            (click)="onInfoClick($event, 'showChartLabels')">
                        i
                    </button>
                </label>
                <div class="form-control" (click)="hideTooltip()">
                    <input type="checkbox"
                           id="showChartLabels"
                           class="form-check-input"
                           [(ngModel)]="showLabels" />
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('showChartLabels')"
                     (click)="hideTooltip()">
                    {{ info('showChartLabels') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Label Font Color -->
    <div class="row" *ngIf="showLabels && selectedChartType != 'list'">
        <div class="col-lg-10">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="labelFontColor"
                       title="Color of datapoint labels">
                    Label Font Color
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('labelFontColor')"
                            (click)="onInfoClick($event, 'labelFontColor')">
                        i
                    </button>
                </label>
                <input id="labelFontColor"
                       name="labelFontColor"
                       class="form-control"
                       [value]="labelFontColor"
                       [style.background]="labelFontColor"
                       [(colorPicker)]="labelFontColor"
                       [cpPosition]="'top'"
                       (click)="hideTooltip()" />

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('labelFontColor')"
                     (click)="hideTooltip()">
                    {{ info('labelFontColor') }}
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <button class="btn btn-default"
                    (click)="setDefaultLabelFontColor(); hideTooltip()"
                    title="Reset to Default">
                <i class="fa fa-refresh"></i>
            </button>
        </div>
    </div>

    <!-- Label Font Size -->
    <div class="row" *ngIf="showLabels && selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="labelFontSize"
                       title="Size of datapoint labels">
                    Label Font Size
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('labelFontSize')"
                            (click)="onInfoClick($event, 'labelFontSize')">
                        i
                    </button>
                </label>
                <input id="labelFontSize"
                       name="labelFontSize"
                       type="number"
                       class="form-control"
                       [(ngModel)]="labelFontSize"
                       min="8"
                       max="72"
                       (click)="hideTooltip()" />

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('labelFontSize')"
                     (click)="hideTooltip()">
                    {{ info('labelFontSize') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Label Anchor Position -->
    <div class="row" *ngIf="showLabels && selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="labelAnchorPosition"
                       title="Area labels will display within datapoint rendering">
                    Label Anchor Position
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('labelAnchorPosition')"
                            (click)="onInfoClick($event, 'labelAnchorPosition')">
                        i
                    </button>
                </label>
                <select id="labelAnchorPosition"
                        name="labelAnchorPosition"
                        [(ngModel)]="labelAnchorPosition"
                        class="form-control"
                        (click)="hideTooltip()">
                    <option value="center">Center</option>
                    <option value="end">End</option>
                    <option value="start">Start</option>
                </select>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('labelAnchorPosition')"
                     (click)="hideTooltip()">
                    {{ info('labelAnchorPosition') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Label Alignment -->
    <div class="row" *ngIf="showLabels && selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="labelAlignment"
                       title="Where labels display relative to anchor position">
                    Label Alignment
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('labelAlignment')"
                            (click)="onInfoClick($event, 'labelAlignment')">
                        i
                    </button>
                </label>
                <select id="labelAlignment"
                        name="labelAlignment"
                        [(ngModel)]="labelAlignment"
                        class="form-control"
                        (click)="hideTooltip()">
                    <option value="center">Center</option>
                    <option value="end">End</option>
                    <option value="start">Start</option>
                    <option value="right">Right</option>
                    <option value="bottom">Bottom</option>
                    <option value="left">Left</option>
                    <option value="top">Top</option>
                </select>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('labelAlignment')"
                     (click)="hideTooltip()">
                    {{ info('labelAlignment') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Label Offset -->
    <div class="row"
         *ngIf="showLabels && labelAlignment !== 'center' && selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       for="labelOffset"
                       title="Offset distance for labels in px">
                    Label Offset
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('labelOffset')"
                            (click)="onInfoClick($event, 'labelOffset')">
                        i
                    </button>
                </label>
                <input id="labelOffset"
                       name="labelOffset"
                       type="number"
                       class="form-control"
                       [(ngModel)]="labelOffset"
                       min="-100"
                       max="100"
                       (click)="hideTooltip()" />

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('labelOffset')"
                     (click)="hideTooltip()">
                    {{ info('labelOffset') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Show Data Values for DataPoint Labels -->
    <div class="row" *ngIf="showLabels && selectedChartType != 'list'">
        <div class="col-lg-12">
            <div class="form-group input-group has-feedback" style="position: relative;">
                <label class="control-group input-group-addon"
                       style="vertical-align: top; white-space: break-spaces; text-align: left; line-height: 1.5em;"
                       title="Details displayed in datapoint labels">
                    Datapoint Labels
                    <button class="info-btn"
                            type="button"
                            [attr.title]="info('datapointLabelsChooser')"
                            (click)="onInfoClick($event, 'datapointLabelsChooser')">
                        i
                    </button>
                </label>

                <div class="form-control"
                     [ngStyle]="{
               height: 'unset',
               'min-height':
                 (labelSetOptions | includeSelected : selectedLabelSetOptions)?.length === 1
                 ? '60px' : null
             }"
                     (click)="hideTooltip()">
                    <ng-container *ngIf="(labelSetOptions | includeSelected : selectedLabelSetOptions)?.length > 0; else noOptions">
                        <div *ngFor="let option of labelSetOptions | includeSelected : selectedLabelSetOptions"
                             class="form-check">
                            <input type="checkbox"
                                   class="form-check-input"
                                   [id]="'dp-' + option"
                                   [value]="option"
                                   [checked]="selectedLabelSetOptions2.includes(option)"
                                   (change)="toggleLabelOption2(option)" />
                            <label [for]="'dp-' + option" class="form-check-label">
                                {{ option }}
                            </label>
                        </div>
                    </ng-container>
                    <ng-template #noOptions>
                        <p>Select columns from the Legend options above to populate this list.</p>
                    </ng-template>
                </div>

                <div class="click-tooltip"
                     *ngIf="isTooltipVisible('datapointLabelsChooser')"
                     (click)="hideTooltip()">
                    {{ info('datapointLabelsChooser') }}
                </div>
            </div>
        </div>
    </div>

    <!-- Color Scheme Modal -->
    <div bsModal
         #colorSchemeModal="bs-modal"
         class="modal fade"
         [config]="{ keyboard: false, backdrop: 'static' }"
         jz-index="99"
         tabindex="-1"
         role="dialog"
         aria-labelledby="myModalLabel"
         aria-hidden="true"
         (click)="hideTooltip()">
        <div class="modal-dialog" style="width: 90%; max-width: 820px">
            <div class="modal-content" data-bind="with: entity">
                <div class="modal-header">
                    <button type="button"
                            class="close"
                            aria-hidden="true"
                            (click)="cancelColorSchemePickerModal()">
                        &times;
                    </button>
                    <h4 class="modal-title" id="myModalLabel">
                        <span>Chose Chart Color Scheme</span>
                    </h4>
                </div>

                <div class="modal-body" data-bind="with: $data.entity" style="padding: 2em">
                    <!-- Min Colors -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group input-group has-feedback" style="position: relative;">
                                <label class="control-group input-group-addon"
                                       for="minColors"
                                       title="Minimum number of colors in the color scheme">
                                    Min Colors
                                    <button class="info-btn"
                                            type="button"
                                            [attr.title]="info('minColors')"
                                            (click)="onInfoClick($event, 'minColors')">
                                        i
                                    </button>
                                </label>
                                <input id="minColors"
                                       name="minColors"
                                       type="number"
                                       class="form-control"
                                       [(ngModel)]="minColors"
                                       min="1"
                                       max="100"
                                       (click)="hideTooltip()" />

                                <div class="click-tooltip"
                                     *ngIf="isTooltipVisible('minColors')"
                                     (click)="hideTooltip()">
                                    {{ info('minColors') }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal Color Scheme select -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group input-group has-feedback" style="position: relative;">
                                <label class="control-group input-group-addon"
                                       for="color-scheme">
                                    Color Scheme
                                    <button class="info-btn"
                                            type="button"
                                            [attr.title]="info('modalColorScheme')"
                                            (click)="onInfoClick($event, 'modalColorScheme')">
                                        i
                                    </button>
                                </label>
                                <select id="color-scheme"
                                        [(ngModel)]="colorScheme"
                                        class="form-control"
                                        (click)="hideTooltip()">
                                    <option value="" [selected]="colorScheme === ''">-- Select Color Scheme --</option>
                                    <optgroup *ngFor="let schemeGroup of objectKeys(colorSchemeObject)"
                                              [label]="schemeGroup">
                                        <option *ngFor="let scheme of objectKeys(colorSchemeObject[schemeGroup])"
                                                [value]="schemeGroup + '.' + scheme"
                                                [selected]="colorScheme === schemeGroup + '.' + scheme">
                                            {{ scheme }}
                                        </option>
                                    </optgroup>
                                </select>

                                <div class="click-tooltip"
                                     *ngIf="isTooltipVisible('modalColorScheme')"
                                     (click)="hideTooltip()">
                                    {{ info('modalColorScheme') }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="scheme-preview">
                        <div *ngFor="let schemeGroup of objectKeys(colorSchemeObject)" class="scheme-group">
                            <h4>{{ schemeGroup }}</h4>
                            <div *ngFor="let scheme of objectKeys(colorSchemeObject[schemeGroup] | filterSchemes : minColors)"
                                 class="scheme"
                                 [class.selectedScheme]="colorScheme === schemeGroup + '.' + scheme"
                                 (click)="selectColorScheme(schemeGroup, scheme, colorSchemeObject[schemeGroup][scheme])">
                                <span>{{ scheme }}</span>
                                <div class="preview">
                                    <div *ngFor="let color of colorSchemeObject[schemeGroup][scheme]"
                                         [style.background-color]="color"
                                         class="color-box"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12"><span>&nbsp;</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>